import { useEffect, useState } from 'react';
import { messaging } from '../utils/firebase';
import { getToken } from 'firebase/messaging';
import { STORAGE_KEYS } from '../config';
import useNotification from './useNotification';

export default function usePushNotification() {
  const [allowedPushNotification, setAllowPushedNotification] = useState(false);
  const [fcmToken, setFcmToken] = useState<string>();

  const allowNotification = useNotification();

  const requestNotification = async () => {
    // Check if the browser supports push notifications.
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      console.log('**************** Browser supports push notifications ****************');
      try {
        // Register the service worker.
        // const swReg = await navigator.serviceWorker.register("/sw.js");
        // Subscribe for push notifications.
        // const pushSubscription = await swReg.pushManager.subscribe({
        //   userVisibleOnly: true
        // });
        // Save the push subscription to the database.
        // savePushSubscription(pushSubscription);

        messaging().then((m) => {
          if (m) {
            getToken(m, {
              vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
            })
              .then((currentToken) => {
                if (currentToken) {
                  console.log('**************** currentToken ****************', currentToken);
                  setFcmToken(currentToken);
                } else {
                  // Show permission request UI
                  console.log(
                    'No registration token available. Request permission to generate one.'
                  );
                }
              })
              .catch((err) => {
                console.log('An error occurred while retrieving token. ', err);
              });
          }
        });
      } catch (error) {
        // Handle errors.
        console.error('Error subscribing for push notifications.', error);
      }
    } else {
      // Push notifications are not supported by the browser.
      console.error('Push notifications are not supported by the browser.');
    }
  };

  useEffect(() => {
    if (allowNotification) {
      requestNotification();
    }
  }, [allowNotification]);

  return fcmToken;
}
